
import React from 'react';
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { X } from 'lucide-react';
import { DateDebugger } from '@/components/debug/DateDebugger';
import { formatDate } from '@/utils/dateTimeFormatters';

interface MatchDetailsProps {
  matches: any[];
  team: string;
  type: 'wins' | 'draws' | 'losses' | 'form';
  onClose: () => void;
}

const MatchDetails: React.FC<MatchDetailsProps> = ({ matches, team, type, onClose }) => {
  return (
    <div className="p-4 space-y-2">
      <div className="flex justify-between items-center">
        <h4 className="font-semibold">
          {type === 'form' ? `${team}'s Match Details` : `${team}'s ${type.charAt(0).toUpperCase() + type.slice(1)}`}
        </h4>
        <Button
          variant="ghost"
          size="icon"
          onClick={onClose}
          className="h-8 w-8 p-0"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
      <div className="space-y-4">
        {matches.map((match, idx) => {
          console.log(`MatchDetails - Match ${idx} date:`, match.Date, 'Type:', typeof match.Date);
          
          // Normalize the date format for consistent display
          const displayDate = formatDate(match.Date);
          
          return (
            <Card key={idx} className="p-4">
              <div className="space-y-4">
                <DateDebugger dateValue={match.Date} label={`Match ${idx} Date`} />
                <div className="flex justify-between items-center border-b pb-2">
                  <span className="text-sm text-gray-600">Date: {displayDate}</span>
                  <span className="text-sm font-medium">
                    {match.HomeTeam} vs {match.AwayTeam}
                  </span>
                </div>
                <div className="grid grid-cols-2 gap-6">
                  <div>
                    <h4 className="text-sm font-medium mb-2">Match Stats</h4>
                    <div className="text-sm space-y-1">
                      <p>Full Time: {match.FTHG} - {match.FTAG}</p>
                      <p>Half Time: {match.HTHG} - {match.HTAG}</p>
                      <p>Corners: {match.HC || 0} - {match.AC || 0}</p>
                    </div>
                  </div>
                  <div>
                    <h4 className="text-sm font-medium mb-2">Additional Info</h4>
                    <div className="text-sm space-y-1">
                      <p>Shots: {match.HS} - {match.AS}</p>
                      <p>Shots on Target: {match.HST} - {match.AST}</p>
                      <p>Fouls: {match.HF} - {match.AF}</p>
                      <p>Cards: 🟨 {match.HY}-{match.AY} 🟥 {match.HR}-{match.AR}</p>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default MatchDetails;
